<h2 mat-dialog-title class="admin-subheader">{{ title }}</h2>
<mat-dialog-content>
    <p class="admin-text">
        @for(chunk of textChunks; track chunk) {
            @if(chunk.isStrong) {
                <strong>{{ chunk.text }}</strong>
            } @else {
                {{ chunk.text }}
            }
        }
    </p>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button (click)="onCancel()"> {{ cancelButtonText }}</button>
    <button mat-button (click)="onDelete()" cdkFocusInitial> {{ confirmButtonText }}</button>
</mat-dialog-actions>